var isBuffer = {exports: {}};

export { isBuffer as __module };
//# sourceMappingURL=isBuffer.js.map
